import env from '../../../../config/environment'

class ConfigItemService
  @$inject = ['httpService']

  constructor: (@httpService) ->
    @url = '/base/config-item/'

  getConfigs: (filtro, callback, event, loadText) ->
    @httpService.request({
      url: env.legacy_url + '/api' + @url,
      method: "POST",
      data: filtro
      clickEvent: event,
      loadingText: loadText,
      blockScreen: true,
      onSuccess: (data) ->
        callback(data);
    })

  getConfig: (filtro, callback, event, loadText) ->
    @getConfigs([filtro], (data) =>
      callback(data[filtro.resource]?[filtro.identificador]?[filtro.resourceId || 'default'])
    , event, loadText)

  getResources: (module, callback, event, loadText) ->
    @httpService.request({
      url: env.legacy_url + '/api' + @url + 'resources' + (if module then '?module=' + module else ''),
      method: "GET",
      clickEvent: event,
      loadingText: loadText,
      blockScreen: true,
      onSuccess: (data) ->
        callback(data);
    })

  saveConfigs: (data, callback, event, loadText) ->
    @httpService.request({
      url: env.legacy_url + '/api' + @url + 'save',
      method: "PUT",
      data: data
      clickEvent: event,
      loadingText: loadText,
      blockScreen: true,
      onSuccess: (data) ->
        callback(data);
    })

angular.module('eficienciaFiscalModule').service('configItemService', ConfigItemService)
